import React from "react";
import { useEffect } from "react";
import ArrayProduct from "../Components/ArrayProduct/ArrayProduct";
function ArrayProductpage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ArrayProduct />
    </>
  );
}

export default ArrayProductpage;
